import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CategoriesComponent} from './categories/categories.component';
import {ArticleComponent} from './article/article.component';
import {BlogCategoryComponent} from './blog-category/blog-category.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {DirectivesModule} from '../../directives/directives.module';


@NgModule({
    declarations: [
        CategoriesComponent,
        ArticleComponent,
        BlogCategoryComponent
    ],
    exports: [
        CategoriesComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        DirectivesModule
    ]
})
export class BlogModule {
}
